import * as React from "react"
import TopLayout from "./TopLayout"
import { ErrorBoundary } from "react-error-boundary"
import ErrorFallback from "../../src/components/ErrorFallback"
export { wrapPageElement } from "./wrap-page-element"
import useServiceStatus from "../../src/hooks/useServiceStatus"
import { UserProvider } from "../../src/providers/UserProvider"
import { QueryClientProvider } from "../../src/providers/QueryClientProvider"
import MaintenanceMode from "../../src/components/layouts/MaintenanceMode"
import { FCWithChildren } from "../../src/interfaces/core"

import { ThemeProvider } from "@mui/material/styles"
import {
  CamMuiTheme,
  CookieBanner,
} from "@ucam.uis.devops/ucam-observe-remote-analytics"
import { MyCAppAppProvider } from "../../src/providers/MyCAppAppProvider"
import { ServiceStatusProvider } from "../../src/providers/ServiceStatusProvider"
import { MyCAppApp } from "../../src/config/mycappapp"

const MaintenanceWrapper: FCWithChildren = ({ children }) => {
  const serviceStatus = useServiceStatus()

  if (!serviceStatus || !serviceStatus.maintenance) {
    return <>{children}</>
  }

  return <MaintenanceMode />
}

export type MyCAppRootProps = React.PropsWithChildren<{ myCAppApp?: MyCAppApp }>

export const MyCAppRoot = (props: MyCAppRootProps): React.ReactNode => (
  <TopLayout>
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <QueryClientProvider>
        <MyCAppAppProvider myCAppApp={props.myCAppApp}>
          <ServiceStatusProvider>
            <UserProvider>
              <MaintenanceWrapper>
                <ThemeProvider theme={CamMuiTheme}>
                  <CookieBanner />
                </ThemeProvider>
                {props.children}
              </MaintenanceWrapper>
            </UserProvider>
          </ServiceStatusProvider>
        </MyCAppAppProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </TopLayout>
)
